import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/components/common/SocialMediaIcons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/common/UnlockPill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/common/WelcomeModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/homepage/specials-carousel/SpecialsCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui-common/src/components/common/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui-common/src/components/signin/index.ts");
